exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".singer-form[data-v-a5d211e6]{width:260px;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;padding:20px 36px 20px 20px}.singer-form .amend-signator[data-v-a5d211e6]{position:absolute;width:30px;right:-35px}.singer-form .select[data-v-a5d211e6]{width:100%}.singer-form .tels[data-v-a5d211e6]{position:absolute;top:25px;right:10px;cursor:pointer}.singer-form .tels .icon[data-v-a5d211e6]{width:20px;height:20px;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5d211e6","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/singer-form/index.vue
// module id = 8dzz
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 33 35 36 44 45 46